import type { CompanySettingList } from "hooks/useCompanySettings";
import { useCompanySettings } from "hooks/useCompanySettings";
import { useState } from "react";
import { putCompanySettings } from "store/settingsStore";
import { useAppDispatch } from "store/store";

export const useBooleanSetting = (settingsName: CompanySettingList, onDisable?: () => void) => {
    const dispatch = useAppDispatch();
    const { getCompanySettings } = useCompanySettings();
    const [checked, setChecked] = useState(getCompanySettings(settingsName));

    const onChange = (e: any) => {
        const newValue = e.target.checked;
        setChecked(newValue);
        dispatch(putCompanySettings([{ settingsName, settingsValue: newValue ? "1" : "0" }]));
        if (!newValue) onDisable?.();
    };

    return { checked, onChange };
};
